import React, { useContext } from "react";
import { WhatsUpWhatsNextContext } from "./WhatsUpWhatsNextContext";
import wuwnDesktop from "../../../assets/WUWN FUB Desktop.png";
import wuwnMobile from "../../../assets/WUWN FUB Mobile.png";
import closeSvg from "../../../assets/closeSvg";

const WhatsUpWhatsNext = () => {
  const { wUWNVisible, setWUWNVisible } = useContext(WhatsUpWhatsNextContext);

  return (
    <div className={`fullScreen dark ${wUWNVisible ? "" : "down"}`}>
      <div className="wuwnContainer">
        <div className="displayFlex spacebetween">
          <b>What's up? What's next?</b>
          <span
            onClick={() => {
              setWUWNVisible(false);
            }}
          >
            {closeSvg}
          </span>
        </div>
        <div className="twentyFivePx"></div>
        <div>
          <b className="blue">Mobile</b>
        </div>
        <div>
          Use this guide to update "What's up? What's next?" with your clients
          in Follow Up Boss on FUB's mobile app.
        </div>
        <div className="tenPx"></div>
        <a
          href="https://www.movemortgage.com/wp-content/uploads/2023/09/WUWN-FUB-Mobile.png"
          rel="noopener noreferrer"
          target="_blank"
          className="imgHover"
        >
          <img src={wuwnMobile}></img>
        </a>
        <div className="twentyFivePx"></div>
        <div className="twentyFivePx"></div>
        <div>
          <b className="blue">Desktop</b>
        </div>
        <div>
          Use this guide to update "What's up? What's next?" with your clients
          in Follow Up Boss on your computer.
        </div>
        <div className="tenPx"></div>
        <a
          href="https://www.movemortgage.com/wp-content/uploads/2023/09/WUWN-FUB-Desktop-small-1.png"
          rel="noopener noreferrer"
          target="_blank"
          className="imgHover"
        >
          <img src={wuwnDesktop}></img>
        </a>
      </div>
    </div>
  );
};

export default WhatsUpWhatsNext;
